import { Note } from "common";
import { useNoteAccount } from "./useNoteAccount";

export const useNoteAccountName = (note: Note) => {
  const account = useNoteAccount(note);
  if (account) {
    return `${account.fName} ${account.lName} `;
  }
  return `Deleted Account`;
};
